module.exports = __webpack_public_path__ + "img/city-icon.38d36d5.png";